var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { StyledProgressBar, Wrapper } from "./progressbar.styles";
export const ProgressBar = (_a) => {
    var { progress, track, size = "M", showProgressValue = true, isInverted = false } = _a, restProps = __rest(_a, ["progress", "track", "size", "showProgressValue", "isInverted"]);
    const progressPercent = Math.round((progress / track) * 100);
    return (_jsxs(Wrapper, Object.assign({}, restProps, { isInverted: isInverted, progress: progressPercent }, { children: [_jsx("div", { children: showProgressValue && size !== "S" ? (_jsxs("span", { children: [progressPercent, " %"] })) : ("") }), _jsx(StyledProgressBar, Object.assign({ size: size, showProgressValue: showProgressValue, isInverted: isInverted, progress: progressPercent }, { children: _jsx("div", {}) }))] })));
};
